import styled, { css } from "styled-components";
import type { DisclosureVariantsType } from "./Disclosure";

// STYLES
const noStyleDisclosure = css`
    summary {
        font-family: var(--font-book);
        font-size: 1.3rem;
        line-height: 2rem;
        list-style: none; /* Hide marker on Chrome */
        text-decoration: underline;
        color: var(--color-black);
        /* Hide marker on Safari */
        &::-webkit-details-marker {
            display: none;
        }
    }

    &[open] {
        summary {
            margin-block-end: var(--spacing-3);
        }
    }
`;

const defaultDisclosure = css`
    background-color: var(--color-white);
    border-radius: 4px;
    box-shadow: 0 0 0 1px var(--color-platinum-medium);

    summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-2);
        list-style: none; /* Hide marker on Chrome */
        border-bottom: 1px solid transparent;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        &::-webkit-details-marker {
            display: none;
        }

        & > div {
            display: inline-flex;
            column-gap: var(--spacing-2);
            align-items: center;
        }

        & > svg,
        & > .dxp-icon {
            pointer-events: none;
        }
    }

    &[open] {
        box-shadow: 0 0 0 1px var(--color-black);

        summary {
            border-bottom-color: var(--color-platinum-medium);

            & > svg,
            & > .dxp-icon {
                transform: rotate(180deg);
            }
        }
    }

    &:is(:hover, :focus) {
        box-shadow: 0 0 0 1px var(--color-black);
    }
`;

const financeOption = css`
    summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-2);
        list-style: none;
        background-color: var(--color-white);
        border: 1px solid var(--color-platinum-medium);
        border-radius: 4px;
        &::-webkit-details-marker {
            display: none;
        }

        & > div {
            display: inline-flex;
            column-gap: var(--spacing-2);
            align-items: center;
        }
    }

    &:is(:hover, :focus) {
        summary {
            border-color: var(--color-black);
        }
    }
`;

const specs = css`
    background-color: var(--color-white);
    border-radius: 4px;
    box-shadow: 0 0 0 1px var(--color-platinum-medium);

    summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-2);
        list-style: none; /* Hide marker on Chrome */
        border-bottom: 1px solid transparent;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        &::-webkit-details-marker {
            display: none;
        }

        & > div {
            display: inline-flex;
            column-gap: var(--spacing-2);
            align-items: center;
        }

        & > svg,
        & > .dxp-icon {
            pointer-events: none;
        }
    }

    &[open] {
        box-shadow: 0 0 0 1px var(--color-black);

        summary {
            border-bottom-color: var(--color-platinum-medium);

            & > span svg,
            & > svg,
            & > .dxp-icon {
                transform: rotate(180deg);
            }
        }
    }

    &:is(:hover, :focus) {
        box-shadow: 0 0 0 1px var(--color-black);
    }
`;

// COMPONENTS
export const DisclosureVariants = {
    default: defaultDisclosure,
    "finance-option": financeOption,
    specs,
    "no-style": noStyleDisclosure,
};

const DisclosureVariant = styled.details<{ variant: DisclosureVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${DisclosureVariants[variant]};
        `};
`;

export default DisclosureVariant;
